import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
   providedIn: 'root'
})
export class NotificationService {
   alertDanger(title: string, message: string) {
      return Swal.fire({
         icon: 'error',
         title: title,
         text: message,
         timer: 5000,
         buttonsStyling: false,
         heightAuto: false,
         confirmButtonText: 'Ok, got it!',
         customClass: {
            confirmButton: 'btn btn-primary'
         }
      });
   }

   alertSuccess(message: string) {
      return Swal.fire({
         text: message,
         icon: 'success',
         buttonsStyling: false,
         heightAuto: false,
         confirmButtonText: 'Ok',
         customClass: {
            confirmButton: 'btn btn-primary'
         }
      })
   }

   alertConfirmation(message: string) {
      return Swal.fire({
         text: message,
         icon: 'warning',
         showCancelButton: true,
         buttonsStyling: false,
         heightAuto: false,
         confirmButtonText: 'Yes',
         cancelButtonText: 'No',
         customClass: {
            confirmButton: 'btn btn-danger',
            cancelButton: 'btn btn-active-light'
         }
      });
   }
}
